/* LullaGlow theme — UI behaviour (no dependencies) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const routes = (window.LG && window.LG.routes) || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart', root: '/' };
  const strings = (window.LG && window.LG.strings) || {};

  /* ---------- header: scrolled state + mobile menu ---------- */
  const header = $('[data-header]');
  if (header) {
    let scrolled = false;
    const onScroll = () => {
      const y = window.scrollY;
      const next = scrolled ? y > 4 : y > 40; /* hysteresis so the shrink can't flicker */
      if (next !== scrolled) { scrolled = next; header.classList.toggle('is-scrolled', scrolled); }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  const mobileNav = $('#MobileNav');
  const openBtn = $('[data-menu-open]');
  const setMenu = (open) => {
    if (!mobileNav) return;
    mobileNav.classList.toggle('is-open', open);
    mobileNav.setAttribute('aria-hidden', String(!open));
    if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) { const f = $('a, button', mobileNav); if (f) f.focus(); } else if (openBtn) openBtn.focus();
  };
  if (openBtn) openBtn.addEventListener('click', () => setMenu(true));
  $$('[data-menu-close]').forEach((b) => b.addEventListener('click', () => setMenu(false)));
  if (mobileNav) $$('a', mobileNav).forEach((a) => a.addEventListener('click', () => setMenu(false)));

  /* ---------- reveal on scroll ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  const watchReveal = (root = document) => $$('.reveal:not(.is-in)', root).forEach((el) => io ? io.observe(el) : el.classList.add('is-in'));
  watchReveal();

  /* ---------- toast ---------- */
  let toastTimer;
  const toast = (msg) => {
    const t = $('#Toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-visible'), 2600);
  };

  /* ---------- cart drawer ---------- */
  const drawer = $('#CartDrawer');
  let lastFocus = null;
  const openDrawer = () => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const panel = $('.drawer__panel', drawer);
    if (panel) panel.focus();
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  $$('[data-drawer-close]').forEach((b) => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('is-open')) closeDrawer();
    if (mobileNav && mobileNav.classList.contains('is-open')) setMenu(false);
  });
  $$('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => {
    if (!drawer || document.body.classList.contains('template-cart')) return;
    e.preventDefault();
    openDrawer();
  }));

  const refreshCart = async () => {
    // re-render the drawer contents with the section rendering API via the cart page
    const res = await fetch(`${routes.cart_url}?view=drawer`, { headers: { Accept: 'text/html' } });
    if (!res.ok) return;
    const html = await res.text();
    const box = $('#CartDrawerContents');
    if (box) box.innerHTML = html;
    const count = box ? $('[data-cart-count-src]', box) : null;
    const n = count ? count.dataset.cartCountSrc : null;
    if (n !== null) $$('[data-cart-count]').forEach((el) => { el.textContent = n; });
    $$('.cart-pill').forEach((p) => { p.classList.remove('bump'); void p.offsetWidth; p.classList.add('bump'); });
  };

  const changeLine = async (key, quantity) => {
    if (drawer) drawer.classList.add('is-loading');
    try {
      const res = await fetch(`${routes.cart_change_url}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!res.ok) { const err = await res.json().catch(() => ({})); toast(err.description || err.message || 'Error'); }
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      await refreshCart();
    } finally { if (drawer) drawer.classList.remove('is-loading'); }
  };

  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.dataset.remove, 0); return; }
    const step = e.target.closest('[data-qty-change]');
    if (step) {
      const wrap = step.closest('[data-qty]');
      const input = wrap && $('input', wrap);
      if (!input) return;
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyChange, 10));
      input.value = next;
      if (input.dataset.lineQty) changeLine(input.dataset.lineQty, next);
      else input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (input) changeLine(input.dataset.lineQty, Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form);
    if (btn) btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${routes.cart_add_url}.js`, {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) { toast(data.description || data.message || 'Could not add to cart'); return; }
      await refreshCart();
      if (drawer) openDrawer(); else window.location.href = routes.cart_url;
      toast(strings.added || 'Added to cart');
    } catch (err) {
      form.submit();
    } finally { if (btn) btn.removeAttribute('aria-busy'); }
  });

  /* ---------- product: variants, gallery, qty, sticky bar ---------- */
  const formatMoney = (cents) => {
    const fmt = (window.LG && window.LG.money_format) || '€{{amount}}';
    const v = (cents / 100);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_with_comma_separator') return v.toFixed(2).replace('.', ',');
      if (k === 'amount_no_decimals') return Math.round(v).toString();
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(v).toString();
      return v.toFixed(2);
    });
  };

  $$('[data-product]').forEach((root) => {
    const json = $('[data-product-json]', root);
    if (!json) return;
    const product = JSON.parse(json.textContent);
    const form = $('form[data-type="add-to-cart-form"]', root);
    const idInput = form && $('input[name="id"]', form);
    const submit = form && $('[type="submit"]', form);
    const submitLabel = submit && $('[data-atc-label]', submit);
    const sticky = $('[data-sticky-atc]');

    const selected = () => $$('fieldset[data-option] input:checked', root).map((i) => i.value);
    const findVariant = (opts) => product.variants.find((v) => v.options.every((o, i) => o === opts[i]));

    const update = () => {
      const v = findVariant(selected());
      $$('fieldset[data-option]', root).forEach((fs, idx) => {
        const legendVal = $('[data-option-value]', fs);
        const chosen = $('input:checked', fs);
        if (legendVal && chosen) legendVal.textContent = chosen.value;
        // mark values that cannot be bought with the other current choices
        $$('input', fs).forEach((input) => {
          const opts = selected();
          opts[idx] = input.value;
          const match = findVariant(opts);
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
      if (!v) {
        if (submit) submit.disabled = true;
        if (submitLabel) submitLabel.textContent = strings.unavailable || 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (submit) submit.disabled = !v.available;
      if (submitLabel) submitLabel.textContent = v.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
      $$('[data-price-now]', root).concat($$('[data-sticky-price]')).forEach((el) => { el.textContent = formatMoney(v.price); });
      const was = $('[data-price-was]', root);
      const save = $('[data-price-save]', root);
      if (was && save) {
        const on = v.compare_at_price && v.compare_at_price > v.price;
        was.hidden = !on;
        save.hidden = !on;
        if (on) {
          was.textContent = formatMoney(v.compare_at_price);
          save.textContent = save.dataset.tpl
            ? save.dataset.tpl.replace('[amount]', Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price))
            : save.textContent;
        }
      }
      if (v.featured_media) showMedia(root, v.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };
    $$('fieldset[data-option] input', root).forEach((i) => i.addEventListener('change', update));
    if ($$('fieldset[data-option]', root).length) update();

    if (sticky && form) {
      const target = submit || form;
      const sio = new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0));
      sio.observe(target);
      const sBtn = $('button', sticky);
      if (sBtn) sBtn.addEventListener('click', () => { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
    }
  });

  function showMedia(root, mediaId) {
    const slides = $$('[data-media-id]', root);
    if (!slides.length) return;
    slides.forEach((s) => {
      const on = String(s.dataset.mediaId) === String(mediaId);
      s.classList.toggle('is-active', on);
      if (!on) $$('video', s).forEach((v) => v.pause());
    });
    $$('[data-thumb]', root).forEach((t) => t.setAttribute('aria-current', String(String(t.dataset.thumb) === String(mediaId))));
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-thumb]');
    if (!t) return;
    const root = t.closest('[data-product]');
    if (root) showMedia(root, t.dataset.thumb);
  });
  // swipe on the main gallery
  $$('[data-gallery-main]').forEach((main) => {
    let x0 = null;
    main.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) < 40) return;
      const root = main.closest('[data-product]');
      const thumbs = $$('[data-thumb]', root);
      const i = thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true');
      const next = thumbs[(i + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length];
      if (next) showMedia(root, next.dataset.thumb);
    });
  });

  /* ---------- countdown ---------- */
  $$('[data-countdown]').forEach((el) => {
    const end = new Date(el.dataset.countdown).getTime();
    if (isNaN(end)) return;
    const parts = { d: $('[data-d]', el), h: $('[data-h]', el), m: $('[data-m]', el), s: $('[data-s]', el) };
    const tick = () => {
      let diff = Math.max(0, end - Date.now());
      const d = Math.floor(diff / 864e5); diff -= d * 864e5;
      const h = Math.floor(diff / 36e5); diff -= h * 36e5;
      const m = Math.floor(diff / 6e4); diff -= m * 6e4;
      const s = Math.floor(diff / 1e3);
      if (parts.d) parts.d.textContent = d;
      if (parts.h) parts.h.textContent = String(h).padStart(2, '0');
      if (parts.m) parts.m.textContent = String(m).padStart(2, '0');
      if (parts.s) parts.s.textContent = String(s).padStart(2, '0');
      if (end - Date.now() <= 0) { el.closest('[data-countdown-wrap]')?.classList.add('is-over'); return; }
      setTimeout(tick, 1000);
    };
    tick();
  });

  /* ---------- theme editor ---------- */
  document.addEventListener('shopify:section:load', (e) => watchReveal(e.target));
  if (window.Shopify && window.Shopify.designMode) $$('.reveal').forEach((el) => el.classList.add('is-in'));
})();
